import { Box, Card } from '@nimbus-ds/components';
import OnboardingTaskAccordion from './OnboardingAccordionTasks';
import useNewOnboardingSteps from './useOnboardingTasks';
import './OnboardingTasks.scss';

function NewOnboardingTasks() {
  const { hasCompleted, isError, isLoading, onboardingTasks } =
    useNewOnboardingSteps();

  if (hasCompleted || isError) {
    return null;
  }
  return (
    <div className="stratus--onboarding-tasks-container">
      <Card padding="none">
        <Box display="flex" flexDirection="column">
          {isLoading ? (
            <OnboardingTaskAccordion.Skeleton />
          ) : (
            <OnboardingTaskAccordion items={onboardingTasks?.tasks || []} />
          )}
        </Box>
      </Card>
    </div>
  );
}

export default NewOnboardingTasks;
